import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {Route} from "../../model/Wall";

export default function BookmarkCard({bookmark, onBookmarkClick, onBookmarkRemove}) {
    const routeColor = Route.getColorHexString(bookmark.route);
    return (
        <div className="rounded border bg-gray-700 mr-4 p-1 mb-2">
            <div className="flex justify-left space-x-2 justify-between py-0.5 pr-3">
                <div
                    className="flex justify-center space-x-2 cursor-pointer"
                    onClick={() => onBookmarkClick(bookmark)}
                >
                    <span className="mr-2">{bookmark.route.name}</span>
                    {routeColor &&
                        <div
                            className="h-5 w-5 rounded-full mt-0.5"
                            style={{backgroundColor: routeColor}}
                        ></div>
                    }
                    <span>{bookmark.route.difficulty ?? ""}</span>
                </div>
                <FontAwesomeIcon
                    icon={faXmark}
                    className="mt-1 ml-1 cursor-pointer"
                    onClick={() => onBookmarkRemove(bookmark)}
                />
            </div>
        </div>
    );
}